<template>
  <Layout>

    <div slot="titlebarSecondRow">
      <SubNavBar :struct="tabStructure"></SubNavBar>
    </div>

    <div class="bills">
      <section class="fieldset" style="margin-bottom: 15px;">
        <h3>{{ $t('papers.tabBills.listUnpaid') }}</h3>

        <table class="table" v-if="isUnpaidValid">
          <thead>
          <tr>
            <th>
              {{ $t('papers.table.date') }}
            </th>
            <th>
              {{ $t('papers.table.numInvoice') }}
            </th>
            <th>
              {{ $t('papers.table.amount') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="invoice in invoices.unpaid">
            <td>{{ convertDate(invoice.date_creation) }}</td>
            <td>{{ invoice.numero_facture }}</td>
            <td>{{ invoice.montant }}€</td>
          </tr>
          </tbody>
        </table>
        <div v-else>
          <div class="no-result">{{ $t('papers.tabBills.noBillNotPaied') }}</div>
        </div>
      </section>

      <section class="fieldset">
        <h3>{{ $t('papers.tabBills.listBill10') }}</h3>

        <table class="table" v-if="isPaidValid">
          <thead>
          <tr>
            <th>
              {{ $t('papers.table.date') }}
            </th>
            <th>
              {{ $t('papers.tabBills.numInvoice') }}
            </th>
            <th>
              {{ $t('papers.table.amount') }}
            </th>
            <th>
              &nbsp;
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="invoice in invoices.paid">
            <td>{{ convertDate(invoice.date_creation) }}</td>
            <td><strong>{{ invoice.numero_facture }}</strong></td>
            <td>{{ invoice.montant }}€</td>
            <td>
              <template v-if="parseInt(invoice.eFacturation) == 1">
                <div @click="dlInvoice(invoice.numero_facture)" class="dl-btn" title="Télécharger la facture">
                  <font-awesome-icon icon="file-pdf"
                                     :title="$t('papers.tabBills.dematerializedInvoice')"></font-awesome-icon>
                </div>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-else>
          <div class="no-result">{{ $t('papers.tabBills.noPayedBill') }}</div>
        </div>
      </section>

    </div>

  </Layout>
</template>

<script>
import Layout from '@l/BaseWithToolbar'

import SubNavBar from '@c/ui/SubNavBar'
import axios from 'axios';
import moment from 'moment';

import {mapGetters, mapActions, mapMutations} from 'vuex'


export default {
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {
    this.$store.commit('UI/viewTitle', window.V.$i18n.t('papers.titles.bills'))
  },
  beforeUpdate: function () {

  },
  components: {
    Layout,
    SubNavBar
  },
  computed: {
    ...mapGetters({
      invoices: 'Papers/invoices',
      clientInfos: 'Papers/clientInfos'
    }),
    tabStructure() {
      return [
        {name: window.V.$i18n.t("papers.tabsBar.society") , path: 'papersIndex', permission: 'admin-company-client'},
        {name: window.V.$i18n.t("papers.tabsBar.interlocutors") , path: 'interlocutors', permission: 'admin-contacts-client'},
        {name: window.V.$i18n.t("papers.tabsBar.bills") , path: 'bills', permission: 'admin-bills-client', active: true},
        {name: window.V.$i18n.t("papers.tabsBar.administrativeAsk"), path: 'drc', permission: 'admin-bills-client'}
      ];
    },
    isUnpaidValid() {
      return this.invoices.unpaid && this.invoices.unpaid.length > 0;
    },
    isPaidValid() {
      return this.invoices.paid && this.invoices.paid.length > 0;
    }
  },
  created: function () {

  },
  data() {
    return {}
  },
  destroyed: function () {

  },
  methods: {
    ...mapActions({
      getInvoices: 'Papers/getInvoices',
      donloadInvoice: 'Papers/downloadInvoice'
    }),
    ...mapMutations({
      setViewTitle: 'UI/viewTitle',
      showLoading: 'UI/showLoading',
      addError: 'Messages/addError'
    }),
    convertDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dlInvoice(numero_facture) {
      this.donloadInvoice({invoiceNumber: numero_facture})
          .then(response => {
            var newBlob = new Blob([response.data], {type: 'application/pdf'})

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, numero_facture + ".pdf");
              return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = numero_facture + ".pdf";
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
          })
    }
  },
  mounted: function () {
    this.getInvoices().then(() => {
      this.showLoading(false);
      if (this.clientInfos.isBlocked == 2) {
        this.addError('Votre compte est vérouillé et nécessite une action administrative pour être actif à nouveau. Veuillez prendre contact avec le service administratif (+33247411010).');
      }
    });
  },
  name: '',
  props: {},
  updated: function () {

  },
  watch: {}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/papers/Bills.vue